import { http } from '../http';

export const userConfirmation = async (contactGuid, userLogStatusGuid) => {
  const url = `/public/users/confirmation/${contactGuid}/${userLogStatusGuid}`;
  const baseURL = process.env.BFFV2_BASE_URL;
  const response = await http.post(url, { contactGuid, userLogStatusGuid }, { baseURL });
  if (response?.status !== 201) {
    throw new Error("something went wrong");
  }
  return true;
};

export default {
  userConfirmation,
};

